export default __webpack_public_path__ + "static/media/Drone1 (1).247423ca.jpg";